import { createSelector } from '@ngrx/store';
import find from 'lodash/find';

import { getCitation } from './get.citations';
import { NumberedCitation } from '../../models';

export const getNumberCitationToDelete = createSelector(
  [getCitation],
  ({ references, deletedNumberedCitationId }): NumberedCitation | undefined =>
    deletedNumberedCitationId &&
    find(references, { citationId: deletedNumberedCitationId })
);
